// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"fe7d8e68","216":"b6b83e50","228":"abd7885e","276":"d7db00f7","495":"aad1fb29","559":"7a1270f5","787":"402df12a"}[chunkId] + ".chunk.js";
};